/**
 * Reklamationen (Fachmodul "complaints"): Status und Erledigungsarten.
 *
 * Eine Reklamation durchlaeuft einen einfachen Lebenslauf:
 *
 *   open        - erfasst, noch niemand dran
 *   in_progress - in Bearbeitung
 *   resolved    - erledigt, mit Art der Erledigung
 *   rejected    - abgelehnt (Beanstandung unberechtigt)
 *
 * Erledigte und abgelehnte Vorgaenge lassen sich wieder oeffnen - eine
 * Reklamation ist ein Vorgang, kein festgeschriebener Beleg. Jede
 * Statusaenderung steht im Aenderungsprotokoll.
 */
export const COMPLAINT_STATUSES = [
    'open',
    'in_progress',
    'resolved',
    'rejected',
];
export const COMPLAINT_STATUS_LABELS = {
    open: 'Offen',
    in_progress: 'In Bearbeitung',
    resolved: 'Erledigt',
    rejected: 'Abgelehnt',
};
export const COMPLAINT_RESOLUTION_LABELS = {
    credit_note: 'Gutschrift',
    replacement: 'Ersatzlieferung',
    repair: 'Nachbesserung/Reparatur',
    other: 'Sonstiges',
};
//# sourceMappingURL=complaints.js.map